module.exports = __webpack_public_path__ + "wirewax-offline/8201557/static/media/pxiEyp8kv8JHgFVrJJbecnFHGPezSQ.d5e78c53.woff2";